import React from 'react';

const SortingIcon = ({ size = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 14 24"
    fill="none"
  >
    <path
      d="M10.8965 8.655L9.024 6.7825L7.88067 5.63334C7.3965 5.14917 6.609 5.14917 6.12484 5.63334L3.10317 8.655C2.7065 9.05167 2.99234 9.72833 3.5465 9.72833H6.819H10.4532C11.0132 9.72833 11.2932 9.05167 10.8965 8.655Z"
      fill="#1A0425"
    />
    <path
      d="M10.4534 14.2717H6.81926H3.54676C2.98676 14.2717 2.70676 14.9483 3.10343 15.345L6.1251 18.3667C6.60926 18.8508 7.39676 18.8508 7.88093 18.3667L9.0301 17.2175L10.9026 15.345C11.2934 14.9483 11.0134 14.2717 10.4534 14.2717Z"
      fill="#1A0425"
    />
  </svg>
);
export default SortingIcon;
